import { i18nextServer } from 'app/locales';
import { useTranslation } from 'react-i18next';

import type { UseTranslationOptions } from 'react-i18next';

type UseTranslationServerOptions = Omit<UseTranslationOptions<never>, 'keyPrefix'> & {
  keyPrefix?: string;
};

const useTranslationServer = (ns?: string[] | string, options: UseTranslationServerOptions = {}) => {
  const defaultKeyPrefix = 'data.translations';

  return useTranslation(ns, {
    i18n: i18nextServer,
    keyPrefix: options?.keyPrefix || defaultKeyPrefix,
    ...options,
  });
};

export { useTranslationServer };
